import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { CarrierDepotListComponent } from "./carrier-depot-list.component";
import { CarrierDepotService } from "../service/carrier-depot.service";
import { PaginatorModule } from "primeng/paginator";
import { BusyModule } from "app/busy/busy.module";
import { NgxPaginationModule } from "ngx-pagination";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { FilterModule } from "app/shared/filter/filter.module";
import { CarrierDepotAddModule } from "../carrier-depot-add/carrier-depot-add.module";
import { CarrierDepotDetailsModule } from "../carrier-depot-details/carrier-depot-details.module";
import { NgxLoadingModule } from "ngx-loading";

const routes: Routes = [
  // { path: '', component: CarrierDepotListComponent }
];

@NgModule({
  declarations: [CarrierDepotListComponent],
  imports: [
    CommonModule,
    CarrierDepotAddModule,
    CarrierDepotDetailsModule,
    RouterModule,
    // RouterModule.forChild(routes),
    PaginatorModule,
    NgxPaginationModule,
    NgbModalModule,
    FilterModule,
    NgxLoadingModule.forRoot({}),
  ],
  exports: [CarrierDepotListComponent],
  providers: [CarrierDepotService, AuthWebService],
})
export class CarrierDepotListModule { }
